import React, { useState } from 'react';
import AdSpaceCouponCodesAdminList from './components/AdSpaceCouponCodesAdminList';
import AdSpaceCouponCodesAdminAdd from './components/AdSpaceCouponCodesAdminAdd';
import { Box, Tabs, Tab } from '@mui/material';

const AdSpaceCouponCodesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpace Coupon Codes admin tabs">
        <Tab label="List AdSpace Coupon Codes" />
        <Tab label="Insert AdSpace Coupon Code" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceCouponCodesAdminList />}
        {tab === 1 && <AdSpaceCouponCodesAdminAdd />}
      </Box>
    </Box>
  );
};

export default AdSpaceCouponCodesAdminPage;
